module.exports = __webpack_public_path__ + "img/menu_mens_diet.42decb0e.png";